import React, { useContext } from 'react';

import HeaderContext from './HeaderContext';
import HeaderFlyoutItem from './HeaderFlyoutItem';
import HeaderMegaMenu from './HeaderMegaMenu';
import HeaderMegaMenuMenu from './HeaderMegaMenuMenu';

const HeaderFlyoutMegaMenu = ({ title, id, children }) => {
  const { activeMegaMenu, toggleMegaMenu } = useContext(HeaderContext);

  const toggle = () => {
    toggleMegaMenu(id);
  };

  return (
    <HeaderFlyoutItem
      title={title}
      onClick={toggle}
      isDropdown
      isOpen={id === activeMegaMenu}
    >
      <HeaderMegaMenu isOpen={id === activeMegaMenu}>
        <HeaderMegaMenuMenu
          title={title}
          onClose={toggle}
          isOpen={id === activeMegaMenu}
        >
          {children}
        </HeaderMegaMenuMenu>
      </HeaderMegaMenu>
    </HeaderFlyoutItem>
  );
};

export default HeaderFlyoutMegaMenu;
